export default "__VITE_ASSET__BBQh1E9K__"